import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'replaceString',
})
export class ReplacePipe implements PipeTransform {
  transform(value: any): any {
    return value?.match(/\d+/g);
  }
}
